import type { ReactNode } from "react"
import { useCallback, useState } from "react"

import { SplashScreenContext } from "./SplashScreenContext"

export const SplashScreenProvider = ({ children }: { children: ReactNode }) => {
  const [isVisible, setIsVisible] = useState(true)

  const hideSplash = useCallback(() => {
    setIsVisible(false)
  }, [])

  return (
    <SplashScreenContext.Provider value={{ isVisible, hideSplash }}>
      {children}
    </SplashScreenContext.Provider>
  )
}
